module.exports = __webpack_public_path__ + "img/appQRcodeC.bbd70324.jpg";